import { useEffect, useRef } from 'react'

import type { AppFlowPhase } from '@/src/game/state/appFlowFsm'
import { store } from '@/src/stores/store'
import {
    getActiveMusicId,
    pauseMusicWithOverlay,
    playMusic,
    stopMusic,
} from '@/src/utils/soundPlayer'

const THEME_MUSIC_ID = 'musicTheme' as const
const INTRO_MUSIC_ID = 'musicPause' as const

const THEME_MUSIC_PHASES = new Set<AppFlowPhase>(['start', 'configurator'])

function isThemeMusicPhase(phase: AppFlowPhase): boolean {
    return THEME_MUSIC_PHASES.has(phase)
}

export function useIntroFlowMusic(): void {
    const previousPhaseRef = useRef<AppFlowPhase>(store.appFlowPhase)

    useEffect(() => {
        const previousPhase = previousPhaseRef.current
        const currentPhase = store.appFlowPhase

        if (currentPhase === 'intro') {
            if (previousPhase !== 'intro') {
                pauseMusicWithOverlay(INTRO_MUSIC_ID)
            }
        } else if (previousPhase === 'intro') {
            stopMusic()
        }

        if (isThemeMusicPhase(currentPhase)) {
            const themeAlreadyPlaying = getActiveMusicId() === THEME_MUSIC_ID
            if (!isThemeMusicPhase(previousPhase) || !themeAlreadyPlaying) {
                playMusic(THEME_MUSIC_ID)
            }
        } else if (isThemeMusicPhase(previousPhase) && currentPhase !== 'intro') {
            stopMusic(THEME_MUSIC_ID)
        }

        previousPhaseRef.current = currentPhase
    }, [store.appFlowPhase])
}
